import { defineStore } from "pinia"
import { useAppStore } from "../stores/app"

export const useListsStore = defineStore("lists", {
    state: () => {
        return {
            lists: [],
            loading: false,
            current_list: {
                post_title: "",
                ID: null
            },
            show_delete_dialog: false,
            show_create_dialog: false,
            show_edit_dialog: false,
            list_to_delete: null,
            deleting: false,
            saving: false,
            app: null
        }
        
    },
    actions: {
        fetchLists () {
            this.app = useAppStore()
            console.log("fetch lists")
            this.loading = true
            this.app.get('lists').then(data => {
                this.lists = data.data
                this.loading = false
                console.log(this.lists)
            }).catch(error => {
                console.log("there was an error", error)
            })    
        },
        deleteList (ID) {
            console.log("delete list", ID)
            this.show_delete_dialog = false
            this.loading = true
            this.app.req.delete(`lists/${ID}`)
                .then(data => this.fetchLists())
        },
        // fetchList (ID) {
        //     this.app = useAppStore()
        //     this.loading = true
        //     this.app.get(`lists/${ID}`)
        //         .then(data => {
        //             this.current_list = data.data
        //             this.loading = false
        //         })
        //         .catch(error => {
        //             this.app.showError('Could not retrieve the requested list')
        //             this.loading = false
        //         })

        // }
        // createList: function (list_name) {
        //     this.saving = true
        //     req.post('lists', {list_name}).then(data => {
        //         this.lists = data
        //         this.saving = false
        //     })
        // },
        // maybeCreateList: function(e) {
        //     if(e.keyCode == 13)
        //         this.createList()
        // },
    }
})